/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AutocompleteItemDto, AutocompleteItemMapper } from '@gh/common-shared-data';

import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { ExportPricesDto, ExportPricesLinkDto } from './export-prices.dto';
import { ExportPricesLinkMapper, ExportPricesMapper } from './export-prices.mapper';

export type ExportPricesViewFilter = {
  fromItemCode: string;
  toItemCode: string;
};

export class AutocompleteItemsFilterDto {
  constructor(public searchString: string,
              public fromItemCode?: string) {
  }
}

@Injectable()
export class ExportPricesRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsAutocompleteDataSource(filter: Partial<AutocompleteItemsFilterDto>): SlicedDataSource<AutocompleteItemDto> {
    return this.createSlicedDataSourceGet(
      `${this.bp}/export/items`, { autocomplete: true, ...filter }, void 0, arrayOf(AutocompleteItemMapper));
  }

  findAllAsDataSource(filter: ExportPricesViewFilter): SlicedDataSource<ExportPricesDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/export/items`,
                                          { autocomplete: false, ...filter },
                                          void 0,
                                          arrayOf(ExportPricesMapper));
  }

  getExcelLink(filter: ExportPricesViewFilter): Observable<ExportPricesLinkDto> {
    return this.httpGet(`${this.bp}/export/items/excel`, filter, void 0, ExportPricesLinkMapper);
  }

  getGoogleSpreadsheetLink(filter: ExportPricesViewFilter): Observable<ExportPricesLinkDto> {
    return this.httpGet(`${this.bp}/export/items/google-spreadsheet`, filter, void 0, ExportPricesLinkMapper);
  }

}
